<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
        <div class="box">
          <admin-box-item title="솔루션 관리 서비스 등록">
            <div class="columns is-multiline">
              <div class="column is-12">
                <admin-form-item label="솔루션 관리 서비스 이름">
                  <input class="input"
                         v-model="value.name"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12">
                <admin-form-item label="가격">
                  <input class="input"
                         v-model="value.price"
                         type="number" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12">
                <admin-form-item label="진행 방법">
                  <input class="input"
                         v-model="value.channel"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12">
                <admin-form-item label="프론트 관련 이슈">
                  <input class="input"
                         v-model="value.front_issue"
                         type="number" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12">
                <admin-form-item label="서버 관련 이슈">
                  <input class="input"
                         v-model="value.server_issue"
                         type="number" maxlength="30">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LpRadio from "../../../module/common/LpRadio";
  export default {
    name: "CareServiceCreate",
    components: {LpRadio},
    created() {
      this.getData();
    },
    data() {
      return {
        value: {
          name: '',
          channel: '',
          front_issue: 0,
          server_issue: 0,
          price: 0
        }
      }
    },
    methods: {
      saveData() {
        if(this.$route.query.id) {
          this.$axios.patch(`admin/launchpack/care_service/${this.$route.query.id}`, this.value).then(res=>{
            this.toast('저장되었습니다.');
          })
        } else {
          this.$axios.post('admin/launchpack/care_service', this.value).then(res=>{
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('launchpack/care_service'));
          })
        }
      },
      getData() {
        if(!this.$route.query.id) return;
        this.$axios.get(`admin/launchpack/care_service/${this.$route.query.id}`).then(res=>{
          this.value = res.data;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
